import { render, staticRenderFns } from "./user-integration.vue?vue&type=template&id=fb570ef2&scoped=true&"
import script from "./user-integration.vue?vue&type=script&lang=js&"
export * from "./user-integration.vue?vue&type=script&lang=js&"
import style0 from "./user-integration.vue?vue&type=style&index=0&id=fb570ef2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb570ef2",
  null
  
)

export default component.exports